var scope_0 = require('/opt/build/repo/.cache/caches/gatsby-plugin-mdx/mdx-scopes-dir/28b9c453e8b286ef774575d004089644.js').default;
var scope_1 = require('/opt/build/repo/.cache/caches/gatsby-plugin-mdx/mdx-scopes-dir/4a3ba8c824b6f09d2b57f68782d3be97.js').default;
var scope_2 = require('/opt/build/repo/.cache/caches/gatsby-plugin-mdx/mdx-scopes-dir/57fb8869b48424bbcfbcd00842018673.js').default;
var scope_3 = require('/opt/build/repo/.cache/caches/gatsby-plugin-mdx/mdx-scopes-dir/8e4c2088699c31f21f5753aaae329e65.js').default;export default
        Object.assign({}, scope_0,
scope_1,
scope_2,
scope_3 )
    